import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { KIKI } from "@/constants/testIds";

export function ThemeToggle() {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const saved = localStorage.getItem("kiki_theme");
    const preferred = saved || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
    setTheme(preferred);
    document.documentElement.classList.toggle("dark", preferred === "dark");
  }, []);

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    document.documentElement.classList.toggle("dark", next === "dark");
    localStorage.setItem("kiki_theme", next);
  };

  return (
    <button
      onClick={toggle}
      aria-label="Toggle theme"
      data-testid={KIKI.themeToggle}
      className="h-10 w-10 grid place-items-center border border-border hover:border-foreground transition-colors"
    >
      {theme === "dark" ? <Sun className="w-4 h-4" strokeWidth={1.4} /> : <Moon className="w-4 h-4" strokeWidth={1.4} />}
    </button>
  );
}
